<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <!-- <embed src="../../static/pdf/ParkBills_FAQs.pdf#toolbar=0&navpanes=0" style="width: 100%; height: 75vh" /> -->
      <embed src="https://docs.google.com/gview?embedded=true&url=https://pbills.parkaidemobile.com/static/pdf/ParkBills_FAQs.pdf" style="width: 100%; height: 75vh" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

export default {
  name: "PageFAQ",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      helper: helper,
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'FAQs' },
      ],
    }
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style scoped>
#outerContainer #mainContainer div.toolbar {
  display: none !important; /* hide PDF viewer toolbar */
}
#outerContainer #mainContainer #viewerContainer {
  top: 0 !important; /* move doc up into empty bar space */
}
</style>


// WEBPACK FOOTER //
// src/components/Page/User/PageFAQ.vue